import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {CompanyDto} from "../model/CompanyDto";

class CompanySelectController implements IComponentController {
    records: CompanyDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.client.bindAllCompany(() => this.records);
        $dataHub.onConnected(this.reload);
    }

    reload = () => {
        this.$dataHub.server.companySubscribe(null);
    };

    $onInit(): void {
    }
}

export default angular.module('component.companySelect', [])
    .component('companySelect', {
        template: require('./CompanySelect.html'),
        controller: CompanySelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
